import {
  Business,
  LocationCity,
  MedicalServices,
  Group,
  Archive,
  Fax,
  History,
  BugReport,
  Assessment,
  Settings,
  ListAlt,
  BarChart,
  Contacts,
} from "@mui/icons-material";

export const menuConfig = [
  // {
  //   label: "Clients",
  //   icon: <Business />,
  //   path: "/dashboard/clients",
  //   access: ["superadmin"],
  // },
  // {
  //   label: "Site Services",
  //   icon: <LocationCity />,
  //   path: "/dashboard/site-services",
  //   access: ["superadmin"],
  // },
  // {
  //   label: "Imaging Sites",
  //   icon: <MedicalServices />,
  //   path: "/dashboard/imaging-sites",
  //   access: ["superadmin", "admin"],
  // },
  {
    label: "User Management",
    icon: <Group />,
    path: "/dashboard/user-management",
    access: ["superadmin-nexus", "superadmin"],
  },
  {
    label: "Client Management",
    icon: <Contacts />,
    path: "/dashboard/client-management",
    access: ["superadmin-nexus"],
  },
  {
    label: "Inbound Studies",
    icon: <Archive />,
    path: "/dashboard/inbound-studies",
    access: ["superadmin-nexus", "admin-nexus"],
  },
  // {
  //   label: "Inbound Faxes",
  //   icon: <Fax />,
  //   path: "/dashboard/inbound-faxes",
  //   access: ["superadmin", "admin"],
  // },
  // {
  //   label: "User Audit History",
  //   icon: <History />,
  //   path: "/dashboard/user-audit-history",
  //   access: ["superadmin"],
  // },
  // {
  //   label: "Tickets",
  //   icon: <BugReport />,
  //   path: "/dashboard/tickets",
  //   access: ["superadmin", "admin"],
  // },
  // {
  //   label: "Request Status Report",
  //   icon: <Assessment />,
  //   path: "/dashboard/request-status-report",
  //   access: ["superadmin"],
  // },
  // {
  //   label: "User Setting",
  //   icon: <Settings />,
  //   path: "/dashboard/user-setting",
  //   access: ["superadmin", "admin"],
  // },
  // {
  //   label: "Task Manager",
  //   icon: <ListAlt />,
  //   path: "/dashboard/task-manager",
  //   access: ["superadmin", "admin"],
  // },
  {
    label: "Reports",
    icon: <BarChart />,
    path: "/dashboard/reports",
    access: ["superadmin-nexus", "superadmin"],
  },
];
